export default __webpack_public_path__ + "static/media/bago_1_wounded(11.3.2021).4018ca4d.jpeg";